import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar/Navbar';
import MapChart from './MapChart';
import GetMailComponent from './GetMailComponent';

export default function Home() {
  const [markers, setMarkers] = useState([]); // markers to show on map
  const [allMails, setAllMails] = useState([]); // store all mails for ship data grid

  useEffect(() => {
    if (window.hidePreloader) {
      window.hidePreloader();
    }
  }, []);

  // Called by GetMailComponent when user clicks Plot / Remove
  const setMarkerpoint = (pointValue) => {
    // pointValue: { subject, mailContent, lat, long, clickedButton, itemIndex }
    const lat = parseFloat(pointValue.lat);
    const long = parseFloat(pointValue.long);
    // console.log(lat, long); // Commented for production
    if (pointValue.clickedButton === 'plot') {
      // Add marker (avoid duplicates)
      if (!Number.isNaN(lat) && !Number.isNaN(long)) {
        setMarkers((prev) => {
          const exists = prev.some(
            (m) => parseFloat(m.lat) === lat && parseFloat(m.long) === long && m.subject === pointValue.subject
          );
          if (exists) return prev;
          return [
            ...prev,
            { 
              id: `${pointValue.subject || 'm'}-${prev.length + 1}`,
              subject: pointValue.subject,
              content: pointValue.mailContent,
              ship_name: pointValue.ship_name || "Unknown Ship",
              lat,
              long,
              speed_kts: pointValue.speed_kts,
              speed_raw: pointValue.speed_raw,
              heading_deg: pointValue.heading_deg,
              heading_raw : pointValue.heading_raw,
              is_forwarded : pointValue.is_forwarded,
              arrival_status: pointValue.arrival_status,
              attachments: pointValue.attachments || [],
              received: pointValue.received || "",
            },
          ];
        });
      } else {
        // optional: show alert if coords invalid
        // console.warn('Invalid coordinates for plotting:', pointValue); // Commented for production
      }
    } else if (pointValue.clickedButton === 'remove') {
      // Remove marker(s) with matching lat/long
      if (!Number.isNaN(lat) && !Number.isNaN(long)) {
        setMarkers((prev) => prev.filter((m) => !(parseFloat(m.lat) === lat && parseFloat(m.long) === long)));
      } else {
        // If coords not present, fallback to removing by itemIndex-based logic isn't available here
        // console.warn('Invalid coordinates for removal:', pointValue); // Commented for production
      }
    }
  };

  // Called by GetMailComponent when the Get Mail button is clicked (so the parent can show preloader / other things)
  const toDoOnClickOfGetMail = () => {
    if (window.showPreloader) window.showPreloader();
    // The GetMailComponent will actually fetch and then hide its own backdrop; parent will hide preloader when done.
    // We'll set a short timeout to clear preloader in case child doesn't call us back (safety)
    setTimeout(() => {
      if (window.hidePreloader) window.hidePreloader();
    }, 1000);
  };

  return (
    <div>
      <Navbar />

      <div className="container-fluid mt-3  pl-4 pr-4">
        <div className="row">
          {/* Left: Map area */}
          <div className="col-lg-8 mb-3">
            <div className="card h-100">
              <div className="card-header py-2 d-flex align-items-center justify-content-between">
                <strong>Fleet Map</strong>
                <span className="text-muted small">Last Reported Positions</span>
              </div>
              <div className="card-body p-0" style={{ height: 'calc(95vh - 115px)' }}>
              <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                <MapChart markers={markers} allMails={allMails} />
              </div>

              </div>
            </div>
          </div>

          {/* Right: GetMailComponent (All Mail panel) */}
          <GetMailComponent 
            setMarkerpoint={setMarkerpoint} 
            toDoOnClickOfGetMail={toDoOnClickOfGetMail}
            onMailsUpdate={setAllMails}
          />
        </div>
      </div>
    </div>
  );
}
